import { SxProps, Theme } from '@mui/material';
import { Text } from '../Text';
import { sanitizeRichTextHtml } from '../../Utils/sanitizeRichTextHtml';
import { richTextHtmlToPlainText } from '../../Utils/richTextHtmlToPlainText';
import { useHasHydrated } from './useHasHydrated';

const FOOTER_RICH_TEXT_SX: SxProps<Theme> = {
  '& *': {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit',
  },
  '& p': { margin: 0 },
  '& a, & a:visited, & a:active': {
    color: 'inherit',
    textDecoration: 'underline',
  },
  '& a:hover, & a:focus': {
    color: 'inherit',
    textDecorationColor: 'inherit',
  },
};

interface HeroCarouselFooterTextProps {
  footerText: string;
  className?: string;
  color: string;
  marginTop: number | { xs: number; md: number };
}

export const HeroCarouselFooterText = ({
  footerText,
  className,
  color,
  marginTop,
}: HeroCarouselFooterTextProps) => {
  const hasHydrated = useHasHydrated();
  const sanitizedHtml = hasHydrated ? sanitizeRichTextHtml(footerText) : '';
  const plainTextBeforeHydration = hasHydrated ? '' : richTextHtmlToPlainText(footerText);

  if (!sanitizedHtml && !plainTextBeforeHydration) {
    return null;
  }

  return (
    <Text
      variant="p3"
      className={className}
      mt={marginTop}
      component="div"
      sx={{ color, ...FOOTER_RICH_TEXT_SX }}
    >
      {sanitizedHtml ? (
        <span dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      ) : (
        <span>{plainTextBeforeHydration}</span>
      )}
    </Text>
  );
};
